import {Button, Modal} from "antd";
import React, {useContext, useState} from "react";
import {Navigate} from "react-router-dom";
import '../assets/css/Dentobook.css';
import {FormattedMessage} from "react-intl";
import {MedicalStaff} from "../api-client";
import type {MedicalStaffCreateWithAccess as MedicalStaffCreatePayload} from "../api-client";
import DetailWrapper from "../components/common/DetailWrapper";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import {ExitPromptContext} from "../context/ExitPromptContext";
import {getMedicalStaffFormComponent} from "../utils/medicalUtils";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import {tokenService} from "../services/tokenService";

const MedicalStaffCreate = () => {

    const {setFormDirty} = useContext(ExitPromptContext);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const [goBack, setGoBack] = useState<boolean>(false);

    const { userOrganization } = React.useContext(DentobookApplicationContext);

    const FormComponent = getMedicalStaffFormComponent(userOrganization);

    // Get organization ID directly from JWT (stateless, no race conditions)
    const organizationId = tokenService.getOrganizationIdFromToken();

    if (!organizationId) {
        return <Navigate to="/medical/staff"/>;
    }

    const medicalStaff: MedicalStaffCreatePayload = {
        firstName: '',
        lastName: '',
        organizationId: organizationId,
        role: 'MEDICAL_DOCTOR'
    };

    const handleOk = () => {
        setFormDirty(false);
        setIsModalOpen(false);

        setGoBack(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    if (goBack) {
        return <Navigate to="/medical/staff"/>
    }

    const footer = <div className="modal-btn-wrapper">
        <Button className="modal-btn" onClick={handleCancel}>
            {<FormattedMessage id="cancel"/>}
        </Button>
        <Button className="modal-btn" type="primary" onClick={handleOk}
        >
            {<FormattedMessage id="confirm"/>}
        </Button>
    </div>;

    return (
        <AccessControl accessibleFor={[accessibilityRoles.CLINIC_ADMIN, accessibilityRoles.RECEPTIONIST]}>
            <Modal
                transitionName=""
                className="dentobook-modal"
                okButtonProps={{
                    className: "modal-btn"
                }}
                cancelButtonProps={{
                    className: "modal-btn"
                }}
                footer={footer}
                title={<FormattedMessage id="add_medical_staff"/>}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <br/>
                <h3 className="dentobook-content font-weight-500 font-24 text-align-center"><FormattedMessage
                    id="unsaved_changes"/></h3>
            </Modal>
            <DetailWrapper navigateBack="/medical/staff">
                <h2><FormattedMessage id="add_medical_staff"/></h2>
                <FormComponent
                    setEditMode={() => {
                    }}
                    openModal={() => setIsModalOpen(true)}
                    medicalStaff={medicalStaff}
                    mode={0}
                />
            </DetailWrapper>
        </AccessControl>
    );
};

export default MedicalStaffCreate;